import axios from '@axios'

export default {
  namespaced: true,
  actions: {

    getLinkedBy(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('userGetLinked', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchGeofences(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('geofence', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getOwners(ctx, data) {
      return new Promise((resolve, reject) => {
        axios.get(`userGetLinked`, { params: data})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    fetchGeofence(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`geofence/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    addGeofence(ctx, geofenceData) {
      return new Promise((resolve, reject) => {
        axios.post('geofence', geofenceData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editGeofence(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.put(`geofence/${form.id}`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteGeofence(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`geofence/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    devicesToLink(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('link/get_devices_to_link', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    devicesAssociated(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get(`links`, {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    associateDevices(ctx, {id, data }) {
      return new Promise((resolve, reject) => {
        axios.post(`links`,
          {geofenceId: id, devices : data ,type:'geofenceDevices'})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getDevicesFilters(ctx) {
      return new Promise((resolve, reject) => {
        axios.get(`getDevicesFilters`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    getFilterBy(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('filters/getFilterBy', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    importFile(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.post(`importFile`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
  },
}
